export const formatCurrency = (v, currency = "COP") => {
  const num = Number(v)
  if (!isFinite(num)) return "—"
  return new Intl.NumberFormat("es-CO", {
    style: "currency", currency, maximumFractionDigits: 0,
  }).format(num)
}

export const formatNumber = (v, decimals = 0) => {
  const num = Number(v)
  if (!isFinite(num)) return "—"
  return new Intl.NumberFormat("es-CO", {
    minimumFractionDigits: decimals, maximumFractionDigits: decimals,
  }).format(num)
}

// Cantidades de producto: muestra decimales SOLO si existen (no redondea a
// entero). Clave para clientes que venden por peso (kg). Enteros se ven igual.
export const formatCantidad = (v, maxDecimals = 3) => {
  const num = Number(v)
  if (!isFinite(num)) return "—"
  return new Intl.NumberFormat("es-CO", {
    minimumFractionDigits: 0, maximumFractionDigits: maxDecimals,
  }).format(num)
}

export const formatPercent = (v, decimals = 2) => {
  const num = Number(v)
  if (!isFinite(num)) return "—"
  return `${num.toFixed(decimals)}%`
}

export const formatGrowth = v => {
  const num = Number(v)
  if (!isFinite(num)) return { text: "—", color: "#64748b", icon: "minus" }
  const text = `${num > 0 ? "+" : ""}${num.toFixed(2)}%`
  if (num > 0) return { text, color: "#10b981", icon: "trending-up" }
  if (num < 0) return { text, color: "#ef4444", icon: "trending-down" }
  return { text, color: "#64748b", icon: "minus" }
}

export const formatFecha = iso => {
  if (!iso) return "—"
  try {
    const s = String(iso).substring(0, 10)
    const [y, m, d] = s.split("-")
    if (y && m && d) return `${d}/${m}/${y}`
    return iso
  } catch { return iso }
}

export const PALETA = [
  "#3b82f6", "#10b981", "#f59e0b", "#ef4444", "#8b5cf6",
  "#ec4899", "#06b6d4", "#84cc16", "#f97316", "#6366f1",
]
export const colorPara = i => PALETA[i % PALETA.length]

// Clase ABC → config visual
export const claseABC = clase => {
  switch (clase) {
    case "A": return { color: "#065f46", bg: "#d1fae5", chartColor: "#10b981", label: "A", desc: "Vital — 80% del importe" }
    case "B": return { color: "#1e40af", bg: "#dbeafe", chartColor: "#3b82f6", label: "B", desc: "Importante — siguiente 15%" }
    case "C": return { color: "#92400e", bg: "#fef3c7", chartColor: "#f59e0b", label: "C", desc: "Marginal — cola larga" }
    default:  return { color: "#475569", bg: "#f1f5f9", chartColor: "#94a3b8", label: clase || "—", desc: "" }
  }
}

// Cuadrante BCG → config visual
export const cuadranteBCG = key => {
  switch (key) {
    case "estrellas":
      return {
        label: "Productos Líderes", color: "#065f46", bg: "linear-gradient(135deg, #d1fae5, #a7f3d0)",
        icon: "star", border: "#10b981",
        desc: "Alto volumen + alta rotación — proteger y potenciar",
      }
    case "vacas_lecheras":
      return {
        label: "Productos Maduros", color: "#1e40af", bg: "linear-gradient(135deg, #dbeafe, #bfdbfe)",
        icon: "cash-100", border: "#3b82f6",
        desc: "Alto volumen + baja rotación — generan caja estable",
      }
    case "preguntas":
      return {
        label: "Productos en Crecimiento", color: "#92400e", bg: "linear-gradient(135deg, #fef3c7, #fde68a)",
        icon: "trending-up", border: "#f59e0b",
        desc: "Bajo volumen + alta rotación — potencial de desarrollo",
      }
    case "perros":
      return {
        label: "Productos de Bajo Aporte", color: "#991b1b", bg: "linear-gradient(135deg, #fee2e2, #fecaca)",
        icon: "alert-decagram-outline", border: "#ef4444",
        desc: "Bajo volumen + baja rotación — evaluar descontinuar",
      }
    default:
      return { label: key, color: "#475569", bg: "#f1f5f9", icon: "help", border: "#cbd5e1", desc: "" }
  }
}

// Rotación → config
export const rotacionConfig = rot => {
  switch (rot) {
    case "rapida":     return { label: "Rápida",     color: "#065f46", bg: "#d1fae5", icon: "rocket-launch" }
    case "normal":     return { label: "Normal",     color: "#1e40af", bg: "#dbeafe", icon: "speedometer" }
    case "lenta":      return { label: "Lenta",      color: "#92400e", bg: "#fef3c7", icon: "speedometer-slow" }
    case "inactiva":   return { label: "Inactiva",   color: "#991b1b", bg: "#fee2e2", icon: "stop-circle-outline" }
    default:           return { label: rot || "—",   color: "#475569", bg: "#f1f5f9", icon: "help-circle-outline" }
  }
}

// Tendencia → config
export const tendenciaConfig = t => {
  switch (t) {
    case "creciendo":   return { label: "Creciendo",  color: "#065f46", icon: "trending-up" }
    case "estable":     return { label: "Estable",    color: "#475569", icon: "trending-neutral" }
    case "decreciendo": return { label: "Decreciendo", color: "#991b1b", icon: "trending-down" }
    case "nuevo":       return { label: "Nuevo",      color: "#1e40af", icon: "new-box" }
    default:            return { label: t || "—",     color: "#475569", icon: "help-circle-outline" }
  }
}

// Estabilidad de precio
export const estabilidadConfig = e => {
  switch (e) {
    case "alta":  return { label: "Estable",  color: "#065f46", bg: "#d1fae5" }
    case "media": return { label: "Variable", color: "#92400e", bg: "#fef3c7" }
    case "baja":  return { label: "Inestable", color: "#991b1b", bg: "#fee2e2" }
    default:      return { label: e || "—",   color: "#475569", bg: "#f1f5f9" }
  }
}

// Alertas → config
export const alertaConfig = tipo => {
  switch (tipo) {
    case "precio_inestable":
      return { label: "Precio inestable", color: "#92400e", bg: "#fef3c7", icon: "chart-line-variant" }
    case "baja_distribucion":
      return { label: "Baja distribución", color: "#92400e", bg: "#fef3c7", icon: "source-branch-minus" }
    case "alta_devolucion":
      return { label: "Alta devolución", color: "#991b1b", bg: "#fee2e2", icon: "undo-variant" }
    case "rotacion_inconsistente":
      return { label: "Rotación inconsistente", color: "#991b1b", bg: "#fee2e2", icon: "alert-decagram" }
    case "producto_inactivo":
      return { label: "Inactivo", color: "#475569", bg: "#f1f5f9", icon: "stop-circle-outline" }
    default:
      return { label: tipo || "—", color: "#475569", bg: "#f1f5f9", icon: "alert-circle-outline" }
  }
}

// Días de semana en orden
export const DIAS_SEMANA_ORDEN = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"]

export const rangoDelMes = (year, month) => {
  const yyyy = String(year)
  const mm = String(month).padStart(2, "0")
  const ultimo = new Date(year, month, 0).getDate()
  return {
    fecha_inicio: `${yyyy}-${mm}-01`,
    fecha_fin: `${yyyy}-${mm}-${String(ultimo).padStart(2, "0")}`,
  }
}
